module.exports = __webpack_public_path__ + "img/rebuild_huang_mob1.1333a56d.jpg";